import axios from "axios";
import store from "../store";
import router from "../router";
import { API_URL } from "../App.vue";
import { startAuthentication } from "@simplewebauthn/browser";

const LOGOUT_EVENT = "logout";

const routeExceptions = [
	"login",
	"widget"
];

export const handleLogoutEvent = async (ev) => {
	const currentRoute = router.app.$route.name;

	if (ev.key === LOGOUT_EVENT && ev.newValue) {
		// Ignore widget and login pages
		if (routeExceptions.some(route => currentRoute && currentRoute.indexOf(route) != -1)) {
			return;
		}

		await store.dispatch("login/logout");
	}
};

async function postLoginSteps(loginResponse) {
	await store.dispatch("login/authenticate", loginResponse);

	// If we have a cookie that indicates which sip phone is linked to this computer, use it !
	if ($cookies.isKey("linkedSipIdentity")) {
		const sipIdentity = $cookies.get("linkedSipIdentity");

		// Cleanup to avoid a user being assigned 2 identities simultaneously
		// Also allows extending lifetime of a cookie every connection
		// These MUST be awaited to ensure the order of operations
		await store.dispatch("sip/unAssignUser");
		await store.dispatch("sip/assignUser", sipIdentity);
	} else {
		await store.dispatch("sip/unAssignUser");
	}
};

export const authenticate = async (username, password) => {
	const { data: loginResponse } = await axios.post(`${API_URL}/auth/login`, {
		username,
		password
	});

	postLoginSteps(loginResponse);
};

export const authenticateWithPasskey = async () => {
	const res = await axios.post(`${API_URL}/auth/login/webauthn/options`);

	const options = await res.data;
	const nonce = options.challenge;

	let assertionResponse;

	assertionResponse = await startAuthentication({ optionsJSON: options });
	const { data: loginResponse } = await axios.post(`${API_URL}/auth/login/webauthn/verify`, {
		response: assertionResponse,
		nonce
	});

	postLoginSteps(loginResponse);
};